module.exports = __webpack_public_path__ + "img/banner-img1.ef0a17cd.png";